module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('h1', [_vm._v("Running stats for " + _vm._s(_vm.$store.state.name))]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('stats-card'), _vm._v(" "), (_vm.$store.state.photo.data.length > 0) ? _c('el-card', {
    staticClass: "photo-card",
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Last photo of chip " + _vm._s(_vm.$store.state.photo.chip_id) + " in state " + _vm._s(_vm.$store.state.photo.state))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.getImageData
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('sockets-card'), _vm._v(" "), (_vm.hasResults) ? _c('results-card') : _vm._e(), _vm._v(" "), (_vm.$store.state.chips.length > 0) ? _c('el-card', {
    staticClass: "chips-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Last chips tested")])]), _vm._v(" "), _c('el-collapse', _vm._l((_vm.$store.state.chips), function(chip) {
    return _c('chip-data', {
      key: chip.id,
      attrs: {
        "chip": chip
      }
    })
  }))], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59fff7b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project-progress.vue
// module id = 715
// module chunks = 1